/* eslint-disable @nx/enforce-module-boundaries */
import { Tab, TabList, Tabs, TabPanels, TabPanel } from '@mybridge/ui/tabs';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const ProfileTabs = ({ active = 0, children, profile, isArticle, publicActiveTab, setPublicActiveTab }) => {
  const { isFriend } = useContext(MyNetworkContext);
  const {
    publicArticles,
  } = useContext(PublicProfileContext);
  const { t } = useTranslator();
  const ProfileTabsArray = [
    {
      title: t('profile.post') || 'Post',
      link: '/p/',
    },
    {
      title: t('profile.about') || 'About',
      link: '/p/about',
    },
      ...(publicArticles?.length>0
      ? [
      {
        title: t('navigation.articles') || 'Articles',
        link: '/p/articles',
      },
    ]
  : []),
    ...(isFriend?.(profile)
    ? [
        {
          title: t('profile.photos') || 'Photos',
          link: '/p/photos',
        },
      ]
    : []), ...(isFriend?.(profile)
    ? [
        {
          title: t('profile.videos') || 'Videos',
          link: '/p/videos',
        },
      ]
    : []),
    ...(isFriend?.(profile)&&profile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1
      ? [
          {
            title: t('publicProfile.network') || 'Network',
            link: '/p/network',
          },
        ]
      : []),
  ];

  return (
    <Tabs index={publicActiveTab} onChange={setPublicActiveTab}>
      <TabList
        px={4}
        borderBottomColor="transparent"
        pos="relative"
        zIndex="1"
        overflowX="auto"
        whiteSpace="nowrap"
        flexWrap="nowrap"
        sx={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {ProfileTabsArray.map((t, index) => (
          <Tab key={index} flexShrink={0}>
            {t?.title}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export default ProfileTabs;
